import React from "react";
import SignatureIconContainer from "../../Assets/SignatureIconContainer.svg";
import ReactQuill from "react-quill";
import { useDispatch } from "react-redux";
import { updateItemQuestion } from "../../Redux/Reducer/FormSlices";

const SignatureQuestion = ({
  id,
  question,
  module,
  questionIndex,
  openQuestion,
  setOpenQuestion,
  containerIndex,
}) => {
  console.log(question);
  const hello = question.boxWidth <= "100" ? question.boxWidth : "45%";
  const dispatch = useDispatch();
  const handleQuestionChange = (newQuestion) => {
    console.log(newQuestion);
    dispatch(
      updateItemQuestion({ newQuestion, questionIndex, containerIndex })
    );
  };
  return (
    <>
      <div className="singleQuestion_name_Container">
        {questionIndex + 1}.
        <ReactQuill
          modules={module}
          theme="snow"
          className={`custom ${openQuestion === question.id ? "focus" : ""}`}
          onFocus={() => setOpenQuestion(question.id)}
          onBlur={() => setOpenQuestion(null)}
          value={question.question}
          onChange={handleQuestionChange}
        />
      </div>

      <div
        class="container"
        style={{
          width: `${question.boxWidth}px`,
          height: `${question.boxHeight}px`,
          minWidth: "45%",
          minHeight: "12.2rem",
          maxWidth:"90%",
          maxHeight:"22rem"
        }}
      >
        <div class="content">
          <img src={SignatureIconContainer} alt="Signature" />
          <p>Signature</p>
        </div>
      </div>
    </>
  );
};

export default SignatureQuestion;
